






import { Vue, Component, Prop } from "vue-property-decorator"
import references from "@/data/references"

@Component
export default class Ref extends Vue {
  @Prop(String) protected readonly id: string | undefined

  @Prop({
    type: String,
    required: false,
  })
  protected readonly page: string | undefined

  get reference() {
    if (!this.id) {
      return {}
    }
    const r = references as any
    return r[this.id]
  }
}
